import './submitted-form.scss'

import { faCheckCircle } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useMemo } from 'react'

import Header from '../../components/collections/Header'
import TagManager from '../../lib/tag-manager'

const onClickClose = () => {
    const isInClient = window.liff.isInClient()
    TagManager.clickEvent({
        page: 'promise-to-pay-submitted-form',
        action: 'click',
        field: JSON.stringify({ isInClient }),
    })
    if (isInClient) {
        window.liff
            .sendMessages([
                {
                    type: 'text',
                    text: 'ท่านได้ส่งข้อมูลเรียบร้อยแล้วค่ะ',
                },
            ])
            .then(() => {
                TagManager.popupEvent({
                    page: 'promise-to-pay-submitted-form',
                    action: 'send-message',
                    field: JSON.stringify({ isInClient, status: 'success' }),
                })
            })
            .catch((e) => {
                TagManager.popupEvent({
                    page: 'promise-to-pay-submitted-form',
                    action: 'send-message',
                    field: JSON.stringify({
                        isInClient,
                        status: 'failure',
                        errorCode: e.code,
                        message: e.message,
                    }),
                })
            })
            .finally(() => {
                window.liff.closeWindow()
            })
    }
}

const SubmittedForm: React.FC = () => {
    useMemo(() => {
        TagManager.loadEvent({ page: 'promise-to-pay-submitted-form' })
    }, [])

    return (
        <div className="submitted-form completed">
            <Header title="การชำระค่างวด" cancelable={false} />
            <div className="container abcs-container">
                <FontAwesomeIcon
                    className="checked-with-circle-container"
                    icon={faCheckCircle}
                    size="4x"
                />
                <h6>ส่งข้อมูลเรียบร้อยแล้ว</h6>
                <div className="paragraph-content">
                    <p>
                        ข้อมูลดังกล่าวบริษัทจะใช้เพื่อติดต่อสอบถามการชำระค่างวดกับท่านใกล้วันนัดหมายค่ะ
                    </p>
                    <p style={{ fontWeight: 'bold' }}>
                        อย่างไรก็ดี การกรอกข้อมูลนี้ไม่สามารถเปลี่ยนแปลงวันนัดชำระได้
                        กรุณาชำระค่างวดตรงกับวันนัดตามสัญญาเพื่อรักษาเครดิต
                    </p>
                </div>
            </div>
            <footer className="abcs-container">
                <button type="button" className="abcs-button primary fluid" onClick={onClickClose}>
                    ปิด
                </button>
            </footer>
        </div>
    )
}
export default SubmittedForm
